/**
 * A place for things related to the _ModalStandard shared view
 */
namespace appn.modalStandard {

    const _modalTextSearchSelector: string = '#connectorsDialog.modal.modalHasTextSearch .modalTextSearch';

    export function init() {
        const modalTextSearchInput = $(_modalTextSearchSelector);

        if (!utils.hasValue(modalTextSearchInput))
            return;

        modalTextSearchInput.focus();
        addEvents(modalTextSearchInput); 
    }

    export function initFullscreenToggle(): void {
        $(document).on('click', '.btn-toggle-fullscreen', function() {
            const $btn = $(this);
            const $modal = $btn.closest('.modal');
            const $dialog = $modal.find('.modal-dialog');

            $dialog.toggleClass('modal-fullscreen');
            const isFullscreen = $dialog.hasClass('modal-fullscreen');

            $btn.find('i')
                .toggleClass('fa-expand', !isFullscreen)
                .toggleClass('fa-compress', isFullscreen);

            $modal.trigger('fullscreenToggled', [isFullscreen]);
        });

        $(document).on('hidden.bs.modal', '.modal', function() {
            const $modal = $(this);
            const $dialog = $modal.find('.modal-dialog');

            if ($dialog.hasClass('modal-fullscreen')) {
                $dialog.removeClass('modal-fullscreen');
                $modal.find('.btn-toggle-fullscreen i')
                    .removeClass('fa-compress')
                    .addClass('fa-expand');
            }
        });
    }

    function addEvents(modalTextSearchInput: JQuery<HTMLElement>) {
        modalTextSearchInput.off().on('input', function() {
            // When text is changed in the Form connectors dialog search textbox
            const searchText = $(this).val() as string;

            if (!searchText) {
                showAllConnectors();
                return;
            }

            showMatchedConnectors(searchText);
        });
    }

    function showAllConnectors(): void {
        $(`#connectorsDialog .connectorOption`).showElement();
    }

    function showMatchedConnectors(searchText: string): void {
        $(`#connectorsDialog .connectorOption`).each(function(index, element) {
            const connectorText = $(element).text();

            if (!connectorText.containsIgnoreCase(searchText)) {
                $(element).hideElement();
                return;
            }

            $(element).showElement();
        });
    }

}
